


















































































































import { DetailItem } from "@/store/push/statistic/types";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import {LongTextWings, ScrollButton} from 'wings-ui-components';
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import PushDetailFilter from "@/components/Push/PushDetailFilter.vue";
import { dateFilter } from "@/utils/date-util";

@Component({ components: {PushDetailFilter, ScrollButton, LongTextWings}, filters: {dateFilter} })
export default class PushDetail extends BaseItemsPage<DetailItem> {

  @Getter("pushStatisticDetail") responseItems: any;

  is_show_filter_additional = false;
  currentSort = "create_date";

  tableFields = this.tableFieldsDefault;

  get tableFieldsDefault() {
    return [
      "create_date",
      "application",
      "os",
      "recipient",
      "message",
      "status",
      "partner_price",
      "detail"
    ];
  }

  getData() {
    return this.responseItems;
  }

}
